// Status labels + colors for top-level KPI cards on /projects list.
// Limited to active build pipeline (intake/tender/build).
// Service/inactive are excluded — Service has its own /maintenance page.

export type ProjectKpiStatus = 'intake' | 'tender' | 'build';

export const PROJECT_STATUS_ORDER: ProjectKpiStatus[] = ['intake', 'tender', 'build'];

export const PROJECT_STATUS_LABELS: Record<ProjectKpiStatus, string> = {
  intake: 'Tiếp nhận',
  tender: 'Đấu thầu',
  build: 'Thi công',
};

// border-left accent
export const PROJECT_STATUS_BORDER: Record<ProjectKpiStatus, string> = {
  intake: 'border-l-blue-500',
  tender: 'border-l-amber-500',
  build: 'border-l-green-500',
};

// active ring accent
export const PROJECT_STATUS_RING: Record<ProjectKpiStatus, string> = {
  intake: 'ring-blue-500',
  tender: 'ring-amber-500',
  build: 'ring-green-500',
};
